import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatsLanguages = {
  progressBarAditionalText:
    " to continue! You can always come back and select more games to attend!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Florida Citrus Sports account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager 30 days prior to game day. Reach out to LIve Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "Which sideline is my team on?",
    description: (
      <>
        For the Florida Blue Florida Classic, Bethune-Cookman is on the East
        (101-117, P01-P17, P51-P52) and Florida A&M is on the West (125-143,
        P25-P43)
        <br />
        <br />
        For the Pop-Tarts Bowl, the ACC is on the East (101-117, P01-P17,
        P51-52) and the Big 12 is on the West (125-143, P25-P43)
        <br />
        <br />
        For the Cheez-It Citrus Bowl, the SEC is on the East (101-117, P01-P17,
        P51-P52) and the Big Ten is on the West (125-143, P25-P43)
      </>
    ),
  },
  {
    title: "How does the Florida Citrus Sports Stadium Pass work?",
    description:
      "The Florida Citrus Sports Stadium Pass allows fans to select any seat to select games hosted by Florida Citrus Sports. Simply log into your Florida Citrus Sports Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Tickets are delivered directly within your Florida Citrus Sports Account Manager. ",
  },
];

export const FCSCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const FCSRegistrationTerms = () => (
  <>
    By creating an account you agree to receive email notifications regarding
    your purchase and to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);
